import { render } from "./ModuleTemplate.vue?vue&type=template&id=2bf85218"
import script from "./ModuleTemplate.vue?vue&type=script&lang=js"
export * from "./ModuleTemplate.vue?vue&type=script&lang=js"

import "./ModuleTemplate.vue?vue&type=style&index=0&id=2bf85218&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__